import { useReducer } from "react";
import api from '../../../api/resources';

const intialState = {
  accessTypes: [],
  organizations: [],
  departments: []
};

function reducer(state, action) {
  switch (action.type) {
    case "ACCESS_TYPES":
      return {
        ...state,
        accessTypes: action.accessTypes
      };
    case "ORGANIZATIONS_LIST":
      return {
        ...state,
        organizations: action.organizations
      };
    case "DEPARTMENT_LIST":
      return {
        ...state,
        departments: action.departments
      };
    default:
      return {
        ...state
      };
  }
}

export default function useResourceForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getAccessTypeList() {
    api.getAccessTypes().then(({ data }) => {
      dispatch({ type: "ACCESS_TYPES", accessTypes: data });
    });
  }

  function getOrganizationsList() {
    api.getOrganizationsList().then(({ data }) => {
      dispatch({ type: "ORGANIZATIONS_LIST", organizations: data });
    });
  }

  function getDepartmentsList(id) {
    api.getDepartmentsList(id).then(({ data }) => {
      dispatch({ type: "DEPARTMENT_LIST", departments: data });
    });
  }

  return {
    dataSources,
    getAccessTypeList,
    getOrganizationsList,
    getDepartmentsList
  };
}
